<template>
  <div>
    <Head :title="`${$t('treatments.treatment')} #${data.id}`" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/view`">
        {{ data.applicant_id }}. {{ data.applicant_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/view`">{{data.treatment_type_name}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/interventions/${data.id}/view`">{{$t('interventions.intervention')}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{$t('global.update')}}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore"> {{$t('applicants.trashed_message')}}</trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form"
              :users="users"
              :intervention_types="intervention_types"
              :cooperations="cooperations"
              :locations="locations"
              :statuses="statuses"
              :requests="requests"
              :treatment_type="data.treatment_type_name"
              :send_types="send_types"
              :seen_types="seen_types"
              :is-new="false">
        </Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >{{ $t('global.delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
    Form
  },
  layout: Layout,
  props: {
    data: Object,
    users: Array,
    intervention_types: Array,
    cooperations: Array,
    locations: Object,
    statuses: Object,
    requests: Array,
    send_types: Array,
    seen_types: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        notes: this.data.notes,
        date: this.data.date,
        user_id: this.data.user_id,
        intervention_type_id: this.data.intervention_type_id,
        cooperation_id: this.data.cooperation_id,
        location_id: this.data.location_id,
        status: this.data.status.value,
        request_ids: this.data.request_ids,
        location_field: this.data.location_field,
        request_field: this.data.request_field,
        send_field: this.data.send_field,
        seen: this.data.seen,
      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/interventions/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/interventions/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/interventions/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
